/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';

// icon

// style
// import { globalStyle } from '../../../global/style';
import { styles } from '../style';
import InfographBasin from './InfographBasin';
import './infobasin.css';

const useStyles = makeStyles(styles);

function TabPanel(props) {
  const {
    children, value, index, ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}
const TabContainer = ({ children }) => (
  <Box component="div">
    {children}
  </Box>
);

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

TabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function SituationInfographicBasin() {
  const classes = useStyles();

  function List() {
    return (
      <>
        <Box mt={2}>
          <InfographBasin />
        </Box>
      </>
    );
  }

  return (
    <div className={classes.root}>
      <List />
    </div>
  );
}
